/* src/app/common/components/toast/toast.component.scss */
.toast {
  border-radius: 0.5rem;
  overflow: hidden;
  z-index: 999 !important;
  max-width: unset !important;
}
/*# sourceMappingURL=toast.component-3VTQS6GN.css.map */
